import { render, staticRenderFns } from "./BFootImpressum.vue?vue&type=template&id=a2395aee&scoped=true&"
import script from "./BFootImpressum.vue?vue&type=script&lang=js&"
export * from "./BFootImpressum.vue?vue&type=script&lang=js&"
import style0 from "./BFootImpressum.vue?vue&type=style&index=0&id=a2395aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2395aee",
  null
  
)

export default component.exports